export interface LeagueConfig {
  sport: string;
  requiresRound: boolean;
}

export const LEAGUE_CONFIGS: Record<string, LeagueConfig> = {
  'urba-top-12': {
    sport: 'rugby',
    requiresRound: true
  },
  'conmebol-libertadores': {
    sport: 'futbol',
    requiresRound: false
  }
};

export const leagueRequiresRound = (league?: string): boolean => {
  if (!league) return false;
  return LEAGUE_CONFIGS[league]?.requiresRound ?? false;
};
